import { getFileExtensionFromContentType } from 'src/utils/file-service';

export const useImageUrlToFile = () => {
  const convertImageUrlToFile = async (url: string): Promise<File | null> => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      
      // Get file extension from Content-Type header
      const contentType = response.headers.get('content-type');
      const extension = getFileExtensionFromContentType(contentType, url);
      
      const filename = `image.${extension}`;
      return new File([blob], filename, { type: blob.type });
    } catch (error) {
      console.error('Error converting image URL to file:', error);
      return null;
    }
  };

  return { convertImageUrlToFile };
};
